import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionarySubjectSubKindSelectOption = makeCreateDictionarySelectOption<ISubjectType>('id', 'title');
